module.exports = __webpack_public_path__ + "media/interested_companies/images/bell_fill-7a074951b631d747b3dec5f449faa4b8.svg";